// apps/web/src/stores/utils.ts
import { StateStorage } from 'zustand/middleware';

// Utility function to clear a specific persisted state by name
export const clearPersistedState = (name: string, storage: StateStorage = localStorage) => {
  try {
    storage.removeItem(name);
    console.log(`[AUTH] Cleared persisted state: ${name}`);
  } catch (error) {
    console.error(`[AUTH] Error clearing persisted state ${name}:`, error);
  }
};